module.exports = __webpack_public_path__ + "static/media/mocha.4665ed02.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/mocha.png
// module id = 147
// module chunks = 0